// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expandable-mask[data-v-497e181a]{overflow:hidden;text-overflow:ellipsis;transition:height .25s ease-out 0s;margin-bottom:.5rem}.toggle-text[data-v-497e181a]{cursor:pointer;color:#46aff2}", ""]);
// Exports
module.exports = exports;
